import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconSchool } from "@tabler/icons-react";

import { useScreen } from "Screen/ScreenContext";

import useMyMentoringDetail from "./hooks/useMyMentoringDetail";
import useMentoringRevenue from "./hooks/useMentoringRevenue";
import MyMentoringDetailView from "./view";

/**
 * Creator — single subscribed mentoring (§6.11 detail). Wraps the detail hook,
 * publishes the breadcrumb (Minhas mentorias › {program}) and renders the view.
 * The "Vincular comunidade" CTA (awaiting_community) routes to the attach flow
 * (§6.10).
 */
export default function MyMentoringDetail() {
  const navigate = useNavigate();
  const { t } = useTranslation("member");
  const { setBreadcrumb } = useScreen();
  const { enrollment, loading, notFound } = useMyMentoringDetail();
  const revenue = useMentoringRevenue(enrollment);

  const programName = enrollment?.program?.name;

  useEffect(() => {
    const name = programName ?? t("mentoringDetail.fallbackName");
    document.title = t("mentoringDetail.documentTitle", { name });
    setBreadcrumb([
      { label: t("myMentorings.breadcrumb"), href: "/mentoring", icon: <IconSchool size={18} /> },
      { label: name },
    ]);
    return () => setBreadcrumb(null);
  }, [setBreadcrumb, programName, t]);

  // awaiting_community → the attach flow (§6.10).
  function handleAttach() {
    if (enrollment?.id) navigate(`/mentoring/${enrollment.id}/attach`);
  }

  // Open the full insights page with the community + monthly range prefilled.
  function handleOpenInsights() {
    if (revenue.insightsHref) navigate(revenue.insightsHref);
  }

  return (
    <MyMentoringDetailView
      enrollment={enrollment}
      loading={loading}
      notFound={notFound}
      onAttach={handleAttach}
      revenue={revenue}
      onOpenInsights={handleOpenInsights}
    />
  );
}
